import { Form, Modal, Switch } from "antd"
import { useEffect, useState } from "react"

import type {
  Album,
  AlbumListItem
} from "../../../../../../Album/types/album.types.ts"
import { TextArea } from "../../../../../../../components/Input/TextArea.tsx"
import { TextInput } from "../../../../../../../components/Input/TextInput.tsx"
interface EditAlbumModalProps {
  album: Album | AlbumListItem
  onClose: () => void
  onSubmit?: (data: Partial<Album>) => Promise<void>
}

export function EditAlbumModal({
  album,
  onClose,
  onSubmit
}: EditAlbumModalProps) {
  const [isLoading, setIsLoading] = useState(false)
  const [form] = Form.useForm<Partial<Album>>()

  useEffect(() => {
    form.setFieldsValue({
      name: album.name,
      description: album.description,
      is_visible_to_customer: album.is_visible_to_customer
    })
  }, [album, form])

  const handleClose = () => {
    onClose()
    form.resetFields()
  }

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      setIsLoading(true)

      await onSubmit?.(values)

      handleClose()
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Modal
      title="Edit Album"
      open
      onCancel={handleClose}
      onOk={handleSubmit}
      okText="Save"
      cancelText="Cancel"
      confirmLoading={isLoading}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please enter album name" }]}
        >
          <TextInput placeholder="Album name" maxLength={255} />
        </Form.Item>

        <Form.Item label="Description" name="description">
          <TextArea
            placeholder="Album description"
            rows={3}
            showCount
            maxLength={500}
          />
        </Form.Item>

        <Form.Item
          label="Visible to customer"
          name="is_visible_to_customer"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  )
}
